/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React, { Component } from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import { keys } from '../../../services';
export class OuiComboBoxOption extends Component {
  onClick = () => {
    const {
      onClick,
      option,
      disabled
    } = this.props;

    if (disabled) {
      return;
    }

    onClick(option);
  };
  onKeyDown = event => {
    if (event.key === keys.ENTER || event.key === keys.SPACE) {
      event.preventDefault();
      event.stopPropagation();
      const {
        onEnterKey,
        option,
        disabled
      } = this.props;

      if (disabled) {
        return;
      }

      onEnterKey(option);
    }
  };

  render() {
    const {
      children,
      className,
      disabled,
      isFocused,
      onClick,
      // eslint-disable-line no-unused-vars
      onEnterKey,
      // eslint-disable-line no-unused-vars
      option,
      optionRef,
      ...rest
    } = this.props;
    const classes = classNames('ouiComboBoxOption', className, {
      'ouiComboBoxOption-isDisabled': disabled,
      'ouiComboBoxOption-isFocused': isFocused
    });
    const {
      label
    } = option;
    return <button aria-disabled={disabled} aria-selected={isFocused} className={classes} onClick={this.onClick} onKeyDown={this.onKeyDown} ref={optionRef} role="option" title={label} type="button" {...rest}>
        {children}
      </button>;
  }

}
OuiComboBoxOption.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isFocused: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onEnterKey: PropTypes.func.isRequired,
  option: PropTypes.shape({
    isGroupLabelOption: PropTypes.bool,
    label: PropTypes.string.isRequired,
    key: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      isGroupLabelOption: PropTypes.bool,
      label: PropTypes.string.isRequired,
      key: PropTypes.string,
      options: PropTypes.arrayOf(PropTypes.any.isRequired),
      value: PropTypes.any,
      className: PropTypes.string,
      "aria-label": PropTypes.string,
      "data-test-subj": PropTypes.string
    }).isRequired),
    value: PropTypes.any,
    className: PropTypes.string,
    "aria-label": PropTypes.string,
    "data-test-subj": PropTypes.string
  }).isRequired,
  optionRef: PropTypes.any,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string
};